import { useCallback, useState } from 'react';
import { isSSR } from '../misc/is_ssr';
import { useResize } from './use_resize';

// TODO: Move to Cellula repo.

export function useWindowSize(wait = 250): {
	width?: number;
	height?: number;
} {
	const getWindowSize = useCallback(
		() => ({
			width: isSSR ? undefined : window.innerWidth,
			height: isSSR ? undefined : window.innerHeight,
		}),
		[],
	);
	const [windowSize, setWindowSize] = useState(getWindowSize);

	useResize(() => {
		setWindowSize(getWindowSize);
	}, wait);

	return windowSize;
}
